import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import FormInputText from "../../../../../components/form/FormInputText";
import FormInputNumber from "../../../../../components/form/FormInputNumber";
import FormSelectOpcDataType from "../../../../../components/form/FormSelectOpcDataType";
// INTERFACES
import {
  ReadItemResponseInterface,
  DataRepresentationInterface,
  DataInterface,
} from "../../../../../../interfaces/AdapterCdoOpc.interface";

export default function ComponentReadItemResponse({
  data,
  setData,
}: {
  data: ReadItemResponseInterface;
  setData: (newValue: ReadItemResponseInterface) => void;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onChangeValue = (newValue: string | number, variableName: string) => {
    const copy = structuredClone(data);
    if (variableName === "item_name" && typeof newValue === "string") {
      copy.item_name = newValue;
    } else if (variableName === "group_name" && typeof newValue === "string") {
      copy.group_name = newValue;
    } else if (variableName === "quality" && typeof newValue === "number") {
      copy.quality = newValue;
    }
    setData(copy);
  };

  const parseDataValue = (data_: DataInterface) => {
    const [, dataValue] = Object.entries(data_)[0];
    return dataValue;
  };

  const parseDataKey = (data_: DataInterface): DataRepresentationInterface => {
    const [dataKey]: any = Object.entries(data_)[0];
    return dataKey;
  };

  const setDataType = (newValue: DataRepresentationInterface) => {
    const copy = structuredClone(data);
    if (newValue === "u16") {
      copy.data = { u16: 1 };
    } else if (newValue === "i16") {
      copy.data = { i16: 1 };
    } else if (newValue === "u32") {
      copy.data = { u32: 1 };
    } else if (newValue === "i32") {
      copy.data = { i32: 1 };
    } else if (newValue === "float") {
      copy.data = { float: 1 };
    } else if (newValue === "u64") {
      copy.data = { u64: 1 };
    } else if (newValue === "i64") {
      copy.data = { i64: 1 };
    } else if (newValue === "double") {
      copy.data = { double: 1 };
    } else if (newValue === "string") {
      copy.data = { string: "" };
    }
    setData(copy);
  };

  const onChangeDataValueNumber = (newValue: number) => {
    const copy = structuredClone(data);
    if (parseDataKey(data.data) === "u16") {
      copy.data = { u16: newValue };
    } else if (parseDataKey(data.data) === "i16") {
      copy.data = { i16: newValue };
    } else if (parseDataKey(data.data) === "u32") {
      copy.data = { u32: newValue };
    } else if (parseDataKey(data.data) === "i32") {
      copy.data = { i32: newValue };
    } else if (parseDataKey(data.data) === "float") {
      copy.data = { float: newValue };
    } else if (parseDataKey(data.data) === "u64") {
      copy.data = { u64: newValue };
    } else if (parseDataKey(data.data) === "i64") {
      copy.data = { i64: newValue };
    } else if (parseDataKey(data.data) === "double") {
      copy.data = { double: newValue };
    }
    setData(copy);
  };

  const onChangeDataValueString = (newValue: string) => {
    const copy = structuredClone(data);
    copy.data = { string: newValue };
    setData(copy);
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <FormSelectOpcDataType
        inputValue={parseDataKey(data.data)}
        inputOnChange={setDataType}
        disabledInput={false}
      />
      {parseDataKey(data.data) !== "string" && (
        <FormInputNumber
          inputValue={parseDataValue(data.data)}
          inputLabelName={t("general.dataValue")}
          inputOnChange={onChangeDataValueNumber}
          inputVariableName=""
        />
      )}
      {parseDataKey(data.data) === "string" && (
        <FormInputText
          inputValue={parseDataValue(data.data)}
          inputLabelName={t("general.dataValue")}
          inputOnChange={onChangeDataValueString}
          inputVariableName=""
          isRequired
          disabledInput={false}
        />
      )}
      <FormInputText
        inputValue={data.item_name}
        inputLabelName={t("general.itemName")}
        inputOnChange={onChangeValue}
        inputVariableName="item_name"
        isRequired
        disabledInput={false}
      />
      <FormInputText
        inputValue={data.group_name}
        inputLabelName={t("general.groupName")}
        inputOnChange={onChangeValue}
        inputVariableName="group_name"
        isRequired
        disabledInput={false}
      />
      <FormInputNumber
        inputValue={data.quality}
        inputLabelName={t("general.quality")}
        inputOnChange={onChangeValue}
        inputVariableName="quality"
      />
    </div>
  );
}
